import accountingDocumentsSplitViewStore from './AccountingDocumentsSplitViewStore';
import appStore                          from './AppStore';
import expenseSplitViewStore             from './ExpenseSplitViewStore';
import organigramCollectionStore         from './OrganigramCollectionStore';
import organigramEntityDashboardStore    from './OrganigramEntityDashboardStore';
import organigramStore                   from './OrganigramStore';
import paymentVoucherSplitViewStore      from './PaymentVoucherSplitViewStore';
import { entityReferenceStore }          from './EntityReferenceStore';
import { entityDashboardStore }          from './EntityDashboardStore';
import { entitySplitViewStore }          from './EntitySplitViewStore';

class Store {
	public accountingDocumentsSplitViewStore = accountingDocumentsSplitViewStore;
	public appStore = appStore;
	public entityDashboardStore = entityDashboardStore;
	public entityReferenceStore = entityReferenceStore;
	public entitySplitViewStore = entitySplitViewStore;
	public expenseSplitViewStore = expenseSplitViewStore;
	public organigramCollectionStore = organigramCollectionStore;
	public organigramEntityDashboardStore = organigramEntityDashboardStore;
	public organigramStore = organigramStore;
	public paymentVoucherSplitViewStore = paymentVoucherSplitViewStore;
}

export default new Store();
